import React from "react"

const StackCol = (props) => (
    <div className="stack__col">
        <img src={props.images.img1.publicURL} alt="стек технологий" />
        <img src={props.images.img2.publicURL} alt="стек технологий" />
    </div>
)

export default StackCol